export default __webpack_public_path__ + "static/media/bo_note_D2_D.cd9a87e1.svg";